import Swiper, {Navigation} from 'swiper';

import {Component} from '@lib/Component';
import {MediaQuery} from '@services/MediaQuery';
import {WindowService} from '@services/WindowService';

export class InterviewsDialog extends Component {
  swiper: Swiper | null = null;
  swiperElement: HTMLDivElement | undefined = undefined;
  mq: MediaQuery = MediaQuery.create();
  links: HTMLAnchorElement[] = [];
  close: HTMLAnchorElement | undefined = undefined;
  window = WindowService.create();
  backdrop: HTMLDivElement | undefined = undefined;

  constructor() {
    super();
    this.resize = this.resize.bind(this);
    this.onPressItem = this.onPressItem.bind(this);
    this.onPressClose = this.onPressClose.bind(this);
  }

  didMount() {
    if (this.element) {
      this.window.onResize.connect(this.resize);

      this.backdrop = this.element.querySelector(
        '.o-interview-swiper_backdrop',
      ) as HTMLDivElement;
      this.backdrop.addEventListener('click', this.onPressClose);
      this.close = this.element.querySelector(
        '.o-interview-swiper_close',
      ) as HTMLAnchorElement;
      this.close.addEventListener('click', this.onPressClose);
      this.links = [
        ...this.element.querySelectorAll('.s-interviews_item'),
      ] as HTMLAnchorElement[];
      this.links.map((link) => {
        link.addEventListener('click', this.onPressItem);
      });

      this.swiperElement = this.element.querySelector(
        '.o-interview-swiper',
      ) as HTMLDivElement;
      if (this.swiperElement) {
        this.swiper = new Swiper('.js-interview-swiper', {
          // allowTouchMove: this.mq?.isPhone(),
          autoHeight: false,
          modules: [Navigation],
          navigation: {
            nextEl: '.o-interview-swiper_next',
            prevEl: '.o-interview-swiper_prev',
          },
          on: {
            slideChange: (swiper) => {
              // this.pagination.map((link) => {
              //   link.classList.remove('active');
              // });
              // this.pagination.at(swiper.activeIndex)?.classList.add('active');
            },
          },
          spaceBetween: this.mq?.isPhone() ? 30 : 120,
        });
      }

      this.resize();
    }
  }

  didUnmount() {
    this.backdrop?.removeEventListener('click', this.onPressClose);
    this.close?.removeEventListener('click', this.onPressClose);
    this.links.map((link) => {
      link.removeEventListener('click', this.onPressItem);
    });
    // TODO: remove event listener
    this.swiper?.destroy();
  }

  onPressItem(e: Event) {
    if (e.currentTarget) {
      const index = this.links.indexOf(e.currentTarget as HTMLAnchorElement);
      this.show(index);
    }
  }

  onPressClose() {
    this.hide();
  }

  show(index: number) {
    this.swiper?.slideTo(index, 0);
    this.swiperElement?.classList.add('show');
  }

  hide() {
    this.swiperElement?.classList.remove('show');
  }

  resize() {
    if (this.mq.isPhone()) {
      const height = window.innerHeight;
      this.swiperElement && (this.swiperElement.style.height = `${height}px`);
    } else {
      this.swiperElement && (this.swiperElement.style.height = '');
    }
  }
}
